// src/api.js
import axios from "axios";

const REACT_APP_API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
const APP_NAME = process.env.REACT_APP_APPOINTMENT_URL;

console.log("new-one", REACT_APP_API_BASE_URL);

export const axiosInstance = axios.create({
    baseURL: REACT_APP_API_BASE_URL,
});

axiosInstance.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem("token");
        if (token && token !== "undefined" && token !== "null") {
            const accessToken = JSON.parse(token);
            if (accessToken) {
                config.headers.Authorization = `Bearer ${accessToken}`;
            }
        }
        return config;
    },
    (error) => Promise.reject(error)
);

axiosInstance.interceptors.response.use(
    (response) => response,
    async (error) => {
        return Promise.reject(error);
    }
);
